<template>
  <div id="pdfTemplateAdd">
     <v-container class="pa-0">
      <v-layout style="min-height:70px;">
      <v-flex md6>
        <v-btn fab absolute :to="`/${$route.query.preUrl}`" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" :to="`/${$route.query.preUrl}`">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
     </v-container>
    <v-form ref="pdfTempAdd">
      <v-container>
        <v-layout wrap row>
        <v-flex class="xs12 sm6 md7">
        <v-select 
            v-model="selectAgencies" 
            @change="changedData"
            :items="unselectedAgencies" 
            attach small-chips deletable-chips 
            label="Agencies" 
            :rules="rules"
            required
            multiple
            :disabled="validStatus.length === 1"
            no-data-text="No active agencies found"
            item-text="name"
            item-value="id"
            @input="changedData"
            class="pr-4 pl-4 required">
        </v-select>
        </v-flex>
        <v-flex class="xs12 sm6 md7">
            <upload-btn @file-update="fileSelected($event)" noTitleUpdate :title="title">
            <template slot="icon">
                <v-icon right dark>cloud_upload</v-icon>
            </template>
            <template slot="text-field"></template>
            </upload-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
        </v-flex>
      </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" :to="`/${$route.query.preUrl}`">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store config */  
import { getCollection, create, remove, uploadFile, formatDate, getOne } from '../helpers/helpers';
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { file } from '@babel/types';

export default {
  name: 'pdfTemplateAdd',
  components: {
    'upload-btn': UploadButton,
  },  
  data: () => ({
    entity: 'PdfTemplate',
    roleEntity: 'Account',
    title: 'Select PDF file',
    selectAgencies: [],
    unselectedAgencies: [],
    totalAgencies: [],
    extraParams: {},
    uploadingFile: {},
    config: config,
    selectedData: false,
    validStatus: [],
    rules: [
      v => (v) !== null && v.length !== 0 || 'select atleast one agency'
    ]
  }),
  computed: {
    MyAgencies: {
      set (value) {
        store.commit('setMyAgencies', value);
      },
      get () {
        return store.state.MyAgencies;
      }
    },
    PdfTemplate: {
      get () {
        return store.state.PdfTemplate;
      },
      set (value) {
        store.commit('setPdfTemplate', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    let statusList = ['Active', 'In Progress', 'Approved'];
    await this.roleEntityInitialize();
    this.validStatus = this[this.roleEntity].agency.filter(agency => statusList.indexOf(agency.status) > -1);
    await this.initialize();
    window.getApp.$emit('pageSubHeader', 'Add');
    if (this[this.roleEntity].agency && this.validStatus.length >= 1) {
      this.unselectedAgencies = this.MyAgencies.filter(agency => this.validStatus.findIndex(x => x.agency === agency.id) > -1);
      if (this.validStatus.length === 1) {
        this.selectAgencies.push(this.unselectedAgencies[0].id);
      }
    } else {
      swal.fire({
        title: `<strong>No Active Agencies</strong>`,
        type: 'error',
        html: 'You don\'t have any agencies with Active, In Progress or Approved status to add PDF Profile',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'Close',
        onClose: () => {
          this.$router.push({ path: `/${this.$route.query.preUrl}` });
        }
      });
    }
  },
  methods: {
    async roleEntityInitialize () {
      let populate = '';
      populate = ['human', 'contactInfo.country', 'contactInfo.state', 'template.template'];
      let { error, data } = await getOne(this.roleEntity, this[this.roleEntity].id, populate);
      if (error) {
        console.log(error);
      } else {
        store.commit(`set${this.roleEntity}`, data);
      }
    },
    avaliableAgencies () {
      let activeAgencies = Array.from(this.validStatus, row => row.agency);
      this.totalAgencies = Array.filter(this.MyAgencies, agency => activeAgencies.indexOf(agency.id) !== -1);
      if (this.totalAgencies.length === 1) {
        this.unselectedAgencies = this.totalAgencies;
        this.selectAgencies.push(this.totalAgencies[0].id);
      } else if (this.PdfTemplate.length) {
        let selectedAgencies = this.PdfTemplate.map(template => template.agency);
        let agenciesIds = selectedAgencies.flat();
        this.unselectedAgencies = Array.filter(this.MyAgencies, agency => activeAgencies.indexOf(agency.id) !== -1 && agenciesIds.indexOf(agency.id) === -1);
      } else {
        this.unselectedAgencies = this.totalAgencies;
      }
    },
    async initialize () {
      // Initialize my agencies
      if (this[this.roleEntity].agency && this[this.roleEntity].agency.length) {
        let where = {};
        if (this.roleEntity === 'Child') {
          where['child.child'] = this.Child.id;
        } else {
          where['account.account'] = this.Account.id;
        }

        let attributes = 'name,createdAt,account,child,_id';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.MyAgencies = data;
          }
        }
      }
      // Initialize PDF templates
      if (!this.PdfTemplate.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
        }
        let { error, data, status } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load PdfTemplates'
          };
        } else {
          this[this.entity] = data;
          if (this.validStatus.length !== 1) this.avaliableAgencies();
        }
      } else {
        if (this.validStatus.length !== 1) this.avaliableAgencies();
      }
    },
    async fileSelected (files) {
      this.selectedData = true;
      this.uploadingFile = files;
      this.title = this.uploadingFile.name;
      if (files.type !== 'application/pdf') {
        this.selectedData = false;
        this.uploadingFile = {};
        this.title = 'Select PDF file';
        swal.fire({
          title: `<strong>Upload Error</strong>`,
          type: 'error',
          html: 'Please choose a PDF file',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      
    },
    async save () {
      if (!this.uploadingFile.name) {
        swal.fire({
          title: `<strong>Upload error</strong>`,
          type: 'error',
          html: 'File is required',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      if (this.$refs.pdfTempAdd.validate()) {
        this.selectedData = false;
        let errorHtml = null;
        let files = this.uploadingFile;
        if (files !== 'undefined') {
          this.fileName = files.name;
          if (this.fileName.lastIndexOf('.') <= 0) {
            return;
          }
          if (files.type !== 'application/pdf') {
            errorHtml = 'Please choose a PDF file';
          }
          if (files.size > this.config.uploadFileSize) {
            errorHtml = 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB';
          }
          if (errorHtml) {
            swal.fire({
              title: `<strong>Upload Error</strong>`,
              type: 'error',
              html: errorHtml,
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: 'Close',
            });
            return;
          }
          window.getApp.$emit('AppProgress', true);
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener('load', async () => {
            let postUrl = 'PdfTemplate';
            let extraParams = {
              name: files.name,
              directory: '',
              agency: this.selectAgencies.join()
            };
            if (session.getSession().adminUser) {
              extraParams[this.roleEntity.toLowerCase()] = session.getSession().user.human[this.roleEntity.toLowerCase()].id;
            }
            let response = await uploadFile(postUrl, files, 'POST', extraParams);
            if (!response.$data) {
              window.getApp.$emit('AppProgress', false);
              console.log('error', response.$error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: response.$error
              };
            } else {
              // Create the timeline
              let timelineData = {
                title: 'Profile PDF Uploaded',
                text: `You've uploaded a profile PDF - '${files.name}'`
              };
              timelineData[this.roleEntity.toLowerCase()] = this[this.roleEntity].id;

              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              } else {
                swal.fire({
                  type: 'success',
                  title: 'File uploaded successfully',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                    window.getApp.$emit('AppProgress', false);
                    this.PdfTemplate.unshift(response.$data);
                    this.$router.push({ path: `/${this.$route.query.preUrl}` });
                  }
                });
              }
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    }
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
  #pdfTemplateAdd >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/PDFTemplateAdd.vue